module.exports = __webpack_public_path__ + "static/media/chinese_03.bc3f8bac.jpg";